// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// client don't want this widget anymore --- XSD-10092

// import Notify from "@bg/App/Components/Notify";
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import siteMessage from "@insite/client-framework/SiteMessage";
// import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
// import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
// import loadAccountsReceivable from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/LoadAccountsReceivable";
// import WidgetModule from "@insite/client-framework/Types/WidgetModule";
// import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import CardListHeading from "@insite/content-library/Components/CardListHeading";
// import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
// import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
// import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
// import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
// import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
// import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
// import Typography from "@insite/mobius/Typography";
// import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import * as React from "react";
// import { connect, ResolveThunks } from "react-redux";
// import { css } from "styled-components";

// const enum fields {
//     title = "title",
// }
// interface OwnProps extends WidgetProps {
//     fields: {
//         [fields.title]: string;
//     };
// }
// const mapStateToProps = (state: ApplicationState) => {
//     const session = getSession(state);
//     const isAuthenticated = session.isAuthenticated && !session.isGuest;
//     return {
//         accountsReceivable: getCurrentBillToState(state).value?.accountsReceivable,
//         displayAccountsReceivableBalances: getSettingsCollection(state).customerSettings
//             .displayAccountsReceivableBalances,
//         canViewBuckets: isAuthenticated,
//     };
// };
// const mapDispatchToProps = {
//     loadAccountsReceivable,
// };
// type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
// export interface AgingBucketsStyles {
//     tableWrapper?: InjectableCss;
//     dataTable?: DataTableProps;
//     dataTableHead?: DataTableHeadProps;
//     dataTableHeaders?: DataTableHeaderProps;
//     dataTableBody?: DataTableBodyProps;
//     dataTableRow?: DataTableRowProps;
//     dataCell?: InjectableCss;
//     contentWrapper?: InjectableCss;
// }
// export const agingBucketsStyles: AgingBucketsStyles = {
//     tableWrapper: {
//         css: css`
//             width: 100%;
//             overflow: auto;
//             margin-top: -10px;
//         `,
//     },
//     contentWrapper: {
//         css: css`
//             margin-top: 20px;
//         `,
//     },
// };
// const styles = agingBucketsStyles;
// class AgingBuckets extends React.Component<Props> {
//     componentDidMount() {
//         if (!this.props.accountsReceivable && this.props.displayAccountsReceivableBalances) {
//             this.props.loadAccountsReceivable();
//         }
//     }
//     render() {
//         const { displayAccountsReceivableBalances, accountsReceivable, canViewBuckets, fields } = this.props;
//         if (
//             !canViewBuckets ||
//             !displayAccountsReceivableBalances ||
//             !accountsReceivable ||
//             !accountsReceivable.agingBuckets
//         ) {
//             return null;
//         }
//         const { title } = fields;
//         return (
//             <StyledWrapper
//                 css={css`
//                     .title {
//                         padding-left: 0 !important;
//                     }
//                 `}
//             >
//                 <CardListHeading heading={title} />
//                 <StyledWrapper {...styles.contentWrapper}>
//                     {!accountsReceivable.agingBuckets.length && (
//                         <Notify
//                             messageType="info"
//                             body={<Typography>{siteMessage("Custom_No_Aging_Buckets")}</Typography>}
//                         />
//                     )}
//                     {accountsReceivable.agingBuckets.length && (
//                         <StyledWrapper {...styles.tableWrapper}>
//                             <DataTable {...styles.dataTable}>
//                                 <DataTableHead {...styles.dataTableHead}>
//                                     {accountsReceivable.agingBuckets?.map((bucket, index) => (
//                                         <DataTableHeader
//                                             // eslint-disable-next-line react/no-array-index-key
//                                             key={index}
//                                             tight
//                                             aria-label={bucket.label}
//                                             {...styles.dataTableHeaders}
//                                         >
//                                             {bucket.label}
//                                         </DataTableHeader>
//                                     ))}
//                                 </DataTableHead>
//                                 <DataTableBody {...styles.dataTableBody}>
//                                     <DataTableRow {...styles.dataTableRow} data-test-selector="recentOrders_dataLine">
//                                         {(accountsReceivable.agingBuckets || []).map(
//                                             (bucket, index) =>
//                                                 bucket !== null && (
//                                                     // eslint-disable-next-line react/no-array-index-key
//                                                     <DataTableCell key={`${bucket.amountDisplay}-${index}`}>
//                                                         {bucket.amountDisplay}
//                                                     </DataTableCell>
//                                                 ),
//                                         )}
//                                     </DataTableRow>
//                                 </DataTableBody>
//                             </DataTable>
//                         </StyledWrapper>
//                     )}
//                 </StyledWrapper>
//             </StyledWrapper>
//         );
//     }
// }
// const widgetModule: WidgetModule = {
//     component: connect(mapStateToProps, mapDispatchToProps)(AgingBuckets),
//     definition: {
//         group: "XNGAGE" as any,
//         icon: "List",
//         fieldDefinitions: [
//             {
//                 name: fields.title,
//                 displayName: "Title",
//                 editorTemplate: "TextField",
//                 defaultValue: "Aging Buckets",
//                 fieldType: "General",
//             },
//         ],
//         allowedContexts: ["MyAccountPage"],
//     },
// };
// export default widgetModule;

const Unuse = () => {
    return null;
};

export default Unuse;
